import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import faqData from '../data/faq';

const FAQ = ({ items = faqData, title = 'Frequently Asked Questions' }) => {
  const [openItem, setOpenItem] = useState(null);

  const toggleItem = (index) => {
    setOpenItem(openItem === index ? null : index);
  };

  return (
    <div className="faq-section">
      <h2>{title}</h2>
      <div className="faq-container">
        {items.map((item, index) => (
          <div key={index} className="faq-item">
            <button
              className={`faq-question ${openItem === index ? 'active' : ''}`}
              onClick={() => toggleItem(index)}
              aria-expanded={openItem === index}
            >
              <span>{item.question}</span>
              <svg 
                className={`faq-icon ${openItem === index ? 'rotated' : ''}`}
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </button>
            <div className={`faq-answer ${openItem === index ? 'open' : ''}`}>
              <div className="faq-answer-inner">
                <p>
                  {item.link ? `${item.answer} ` : item.answer}
                  {item.link ? (
                    <Link to={item.link.to} className="learn-more">{item.link.label}</Link>
                  ) : null}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
